var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ef9a10830f94284b80f5a94e6698b1f22585cf31"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["tryup-hp@pluspace"]={id:"ef9a10830f94284b80f5a94e6698b1f22585cf31"};
      